import { RPCResult } from '@campaign-portal/namespace/common/rpc.response';
import { Observable, of } from 'rxjs';

export function ensureDialogCaller<T = unknown>(
	caller$: Observable<RPCResult<T>> | null | undefined,
	fallbackSuccess = false
): Observable<RPCResult<T>> {
	return caller$ ?? of({ Success: fallbackSuccess } as RPCResult<T>);
}
